import { AdvancedImage } from "@cloudinary/react";
import { Galleria } from "primereact/galleria";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState, useRef } from "react";
import ProductViews from "../../../../components/ProductViews/ProductViews";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import useScrollGallery from "./hooks/useScrollGallery";
import FavoriteButton from "../../../../components/FavoriteButton/FavoriteButton";
import { border } from "@cloudinary/url-gen/qualifiers/background";
import { Button } from "primereact/button";
import localeText from "../../../../locale";
import { useLocation } from "react-router-dom";

const responsiveOptions = [
  {
    breakpoint: "1991px",
    numVisible: 4,
  },
  {
    breakpoint: "767px",
    numVisible: 3,
  },
  {
    breakpoint: "575px",
    numVisible: 2,
  },
];

const thumbnailTemplate = (item, index, galleryImages, activeIndex) => {
  return (
    <AdvancedImage
      cldImg={cloudinaryInstance.image(item).format("webp").quality(10)}
      style={{
        border: item === galleryImages[activeIndex] ? "2px solid #46A748" : "2px solid #EBECF0",
        marginBottom: "0",
      }}
      className="p-1 border-round-md"
      width={108}
      height={80}
    />
  );
};

const GalleryImages = ({
  images = [],
  imagesVariations = [],
  currentImageVariation,
  views,
  productId,
  noThumbnail,
}) => {
  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  const { galleryRef, galleryContainerRef, gridStyle } = useScrollGallery();
  const [activeIndex, setActiveIndex] = useState(0);
  const [zoomVisible, setZoomVisible] = useState(false);
  const fullScreenGalleriaRef = useRef(null);

  const galleryImages = [...images, ...imagesVariations];

  useEffect(() => {
    if (currentImageVariation) {
      setActiveIndex(galleryImages.indexOf(currentImageVariation));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentImageVariation]);

  const handleImageChange = ({ index }) => {
    setActiveIndex(index);
  };

  const openZoom = () => {
    setZoomVisible(true);
  };

  const closeZoom = () => {
    setZoomVisible(false);
  };

  // Sincroniza o índice ativo quando o modal de zoom é aberto
  useEffect(() => {
    if (zoomVisible && fullScreenGalleriaRef.current) {
      fullScreenGalleriaRef.current.show();
    }
  }, [zoomVisible]);

  return (
    <div className="h-full" ref={galleryContainerRef}>
      <div ref={galleryRef}>
        <Galleria
          className="relative p-no-outline"
          style={gridStyle}
          value={galleryImages}
          responsiveOptions={responsiveOptions}
          activeIndex={activeIndex}
          onItemChange={handleImageChange}
          showItemNavigators
          numVisible={3}
          item={(item) => (
            <>
              <AdvancedImage
                cldImg={cloudinaryInstance.image(item).format("webp")}
                className="product-selected-image cursor-pointer"
                width="100%"
                height="440px"
                onClick={openZoom}
              />

              {!isFringeBenefitsPage && <FavoriteButton productId={productId} />}
            </>
          )}
          thumbnail={
            noThumbnail
              ? undefined
              : (item, index) => thumbnailTemplate(item, index, galleryImages, activeIndex)
          }
          circular
          showThumbnails={!noThumbnail}
          showIndicators={noThumbnail}
        />

        {/* Modal de zoom com Galleria em tela cheia */}
        <Dialog
          visible={zoomVisible}
          onHide={closeZoom}
          maximized
          modal
          style={{ width: "90vw", height: "90vh" }}
          contentStyle={{ height: "calc(90vh - 6rem)", padding: 0 }}
          className="zoom-dialog custom-dialog-header"
          blockScroll
          header={
            <div className="flex justify-content-between align-items-center">
              <div
                className="flex align-items-center"
                style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap" }}
              >
                <Button
                  link
                  onClick={closeZoom}
                  className="p-button-sm p-no-outline text-xs px-0"
                  style={{ color: "#ffffff" }}
                >
                  <i className="pi pi-arrow-left text-xs mr-2"></i> {localeText("backAction")}
                </Button>
              </div>
              <div
                className="flex align-items-center justify-content-center"
                style={{ width: "100%" }}
              >
                <span
                  className="font-bold text-sm"
                  style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                >
                  {localeText("productImages")}
                </span>
              </div>
              <div className="flex align-items-center" style={{ width: "100%" }}></div>
            </div>
          }
          closeIcon={null}
        >
          <Galleria
            className="relative p-no-outline mx-auto"
            style={{ ...gridStyle, maxWidth: "700px" }}
            value={galleryImages}
            responsiveOptions={responsiveOptions}
            activeIndex={activeIndex}
            onItemChange={handleImageChange}
            showItemNavigators
            numVisible={3}
            item={(item) => (
              <>
                <AdvancedImage
                  cldImg={cloudinaryInstance.image(item).format("webp")}
                  className="product-selected-image cursor-pointer"
                  width="100%"
                  height="100%"
                />
              </>
            )}
            thumbnail={(item, index) => thumbnailTemplate(item, index, galleryImages, activeIndex)}
            circular
          />
        </Dialog>
      </div>
    </div>
  );
};

export default GalleryImages;
